module.exports = __webpack_public_path__ + "img/error-page256.926512a3.png";